var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"submit","disabled":_vm.disabled},domProps:{"value":_vm.schema.buttonText},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }